import { format } from 'date-fns';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';

const ToolTipGraphic: React.FC<TooltipProps<ValueType, NameType>> = ({
  active,
  payload,
}) => {
  if (!active || !payload || payload.length === 0) return null;

  const [item] = payload;

  return (
    <Box
      background={'#b7ffbd'}
      padding={10}
      borderRadius={12}
      flexDirection="column"
      border={'1px solid #005f47'}
      gap={5}
    >
      <Box gap={5}>
        <Text fontSize={18} color="#1b1b1b">
          Viveiro:
        </Text>

        <Text fontSize={18} color="#005f47" fontWeight={700}>
          {item.payload.filter}
        </Text>
      </Box>

      <Box gap={5}>
        <Text fontSize={16} color="#1b1b1b">
          {item.name}:
        </Text>
        <Text fontSize={16} color="#1b1b1b" fontWeight={700}>
          {item.value}
        </Text>
      </Box>

      <Text fontSize={18} color="#1b1b1b">
        {format(new Date(item.payload.date), 'dd/MM/yy - HH:mm')}
      </Text>
    </Box>
  );
};

export default ToolTipGraphic;
